//$.fn.bootstrapSwitch.defaults.size = 'large';
//$.fn.bootstrapSwitch.defaults.onColor = 'success';


// WEBPACK FOOTER //
// src/assets/metronic/src/js/framework/components/plugins/forms/bootstrap-switch.init.js